import ParameterErrors from '../errors/ParameterErrors';
const {throwNotProvided }=ParameterErrors;
export default class FrequencyLimitedCallback {
    constructor(props){
		const {frequencyHz}=props;
		if(frequencyHz===undefined||frequencyHz===null)
			throwNotProvided('frequencyHz');
		this._delay = 1000/frequencyHz;
		this.trigger= this.trigger.bind(this);
		this.cancel= this.cancel.bind(this);
	}
	cancel(){
		this._triggered = false;
	}
	trigger(callback){
		this._callback = callback;
		if(this._pausing){
			this._triggered = true;
			return;
		}
		this._pausing=true;
		this._callback();
		setTimeout(()=>{
			this._pausing=false;
			if(this._triggered){
				this._triggered=false;
				this._callback();
			}
		}, this._delay);
	}
}